import React, { PropsWithChildren } from "react";
import { useWindowClick } from "../hooks/useWindowClick";

export function WindowClickListener(props: PropsWithChildren<{ onClick: () => void }>) {
    useWindowClick(props.onClick);

    return <>{props.children}</>;
}
